import axios from 'axios'
//import APP_CONSTANT from '../../config/config'
//import qs from 'qs';
const allAxiosCommonRequest = async function (props = {}) {
    let token = localStorage.getItem('isloggedIn')
    let userId = localStorage.getItem('userId')
    let user_id = userId
    let customerNo = localStorage.getItem('customerNumber')
    let customer_no = customerNo
    let congData =
    {
        customerNo: customerNo,
        customerNumber: customerNo,
        userId: userId,
        ...props.Items
    }
    let response = await axios.request({
        //baseURL: props.baseURL ? props.baseURL : APP_CONSTANT.BASE_COMMON,
        baseURL: process.env.REACT_APP_BASE_COMMON,
        url: props.method == 'get' ? `${props.url}${props.getValues ? `?${props.getValues}` : props?.noQ ? "" : '?'}customerNo=${customerNo}&customerNumber=${customerNo}&customer_no=${customer_no}&user_id=${user_id}&userId=${userId}${props.hStatus ? `&common_delivery=1&customer_no=${customerNo}&user_id=${userId}` : ''}` : props.url,
        method: props.method,
        data: props.method != 'get' ? congData : '',
        headers: {
            'Content-Type': ` ${props.contentType ? props.contentType : 'application/json'};charset=utf-8`,
            'Authorization': `${token}`
        },
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}
export default allAxiosCommonRequest